import { Icon } from "@iconify/react";
import Connect from "./Connect";
import GetStarted from "../Location/GetStarted";
import Support from "../Location/Support";
import { SocketProvider } from "../../context/socket";

const useRoutes = () => {
  const routes = [
    {
      icon: <Icon icon="flowbite:link-outline" className="menu-icon" />,
      title: "Connection",
      key: "connect",
      route: "/connect",
      component: <Connect />,
    },
    {
      icon: <Icon icon="flowbite:users-group-outline" className="menu-icon" />,
      title: "Get Started",
      key: "get_started",
      route: "/get_started",
      component: <GetStarted />,
    },
    {
      icon: <Icon icon="mdi:headset" className="menu-icon" />,
      title: "Support",
      key: "support",
      route: "/support",
      component: (
        <SocketProvider>
          <Support />
        </SocketProvider>
      ),
    },
  ];
  return routes;
};

export default useRoutes;
